"use client";

import Image from "next/image";
import { fontWeights } from "@/utils/fonts";

interface ProjectOverviewProps {
  title?: string;
  mockupImage?: string;
  borderColor?: string;
  description?: string;
}

export function ProjectOverview({
  title = "Project Overview",
  mockupImage,
  borderColor = "#F1F4F7",
  description
}: ProjectOverviewProps) {
  return (
    <section className="pt-6 sm:pt-8 md:pt-10 lg:pt-12 xl:pt-16 lg:pt-20 px-4 sm:px-6 bg-white">
      <div className="w-full">
        <div className="flex items-center px-3 sm:px-8 md:px-10 lg:px-[98px] py-1.5 sm:py-3 lg:py-4 bg-[#F1F4F7] rounded-[10px] text-[17px] sm:text-[18px] lg:text-[22px] text-[#09155E] shadow-sm max-w-[1220px] mx-auto"
          style={{ fontFamily: "Inter", fontWeight: fontWeights.inter.bold }}>
          {title}
        </div>
      </div>

      {/* Mockup Container with dynamic background color */}
      <div className="max-w-[1313px] mx-auto py-4 sm:py-6 md:py-8 xl:my-10">
        <div
          className="relative w-full aspect-[4/3] md:aspect-[16/9] max-w-[1020px] mx-auto rounded-[10px] sm:rounded-[15px] lg:rounded-[20px] overflow-hidden shadow-2xl flex items-center justify-center"
          style={{ backgroundColor: borderColor }}
        >
          {mockupImage && (
            <Image
              src={mockupImage}
              alt={`${title} Mockup`}
              fill
              className="object-contain p-1 sm:p-6 md:p-8 xl:p-10 lg:p-16 z-10"
              priority
            />
          )}
        </div>
      </div>

      {/* Project Overview Text */}
      <div className="max-w-[1020px] mx-auto">
        <div className="text-[16px] lg:text-[18px] leading-[20px] sm:leading-relaxed text-[#666] space-y-3 sm:space-y-4 md:space-y-6 xl:space-y-8"
          style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}>
          {description?.split('\n').map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
